import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    /* width: 300px; */
    &.ant-card {
        &:hover, &:focus, &:active {
            border: 1px solid #00838d ;
            transition: all 0.2s ease-out;
        }

        .ant-card-body {
            z-index: 0;
            padding: 8px 12px 4px;
            background-color: #f2f8f9;
        }

        &.featured {
            &:hover, &:focus, &:active {
                border: 1px solid #ffc53d ;
                transition: all 0.2s ease-out;
            }

            .ant-card-body {
                background-color: #fffbe6;
            }
        }
    }

    .avatar-col {
        @media only screen and (width <= 350px) {
            display: none;
        }
    }

    .company-name-text {
        font-size: 1rem;
        font-weight: 500;
    }

    .recent-log-in-col {
        &.hidden {
            visibility: hidden;
        }
    }

    .go-corner {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.6rem;
        height: 1.8rem;
        overflow: hidden;
        background: #00838d;
        border-radius: 0 0 0 22px;

        &.featured {
            background: #ffc53d;
        }

        .go-icon {
            margin-top: -4px;
            margin-right: -4px;
            color: white;
        }
    }
`;
